var map = {
	"./android/Device": 1038,
	"./androidtv/Device": 1633,
	"./arris/Device": 1638,
	"./hisense/Device": 1649,
	"./lg/Device": 1657,
	"./nagra/Device": 1666,
	"./netrange/Device": 1677,
	"./opera/Device": 1685,
	"./polaroid/Device": 1693,
	"./ps4/Device": 1701,
	"./samsung/Device": 1709,
	"./seirobotics/Device": 1717,
	"./sony/Device": 1722,
	"./stbcoship/Device": 1730,
	"./stbcoship9108/Device": 1734,
	"./stbhuawei/Device": 1738,
	"./stbkaon/Device": 1742,
	"./tizen/Device": 1745,
	"./web0s/Device": 1754,
	"./workstation/Device": 665,
	"./workstationChafari/Device": 1768,
	"./zeasn/Device": 1776,
	"./zte/Device": 1784
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1037;


//////////////////
// WEBPACK FOOTER
// ./src/devices ^\.\/.*\/Device$
// module id = 1037
// module chunks = 0